module.exports = __webpack_public_path__ + "img/resource1.2255b973.png";